import React from 'react';
import i18n from '../../locales/i18n';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import { countriesByIso, countryIsoFromValue } from '../../services/countryIso';

const CountriesField = ({ name, single, onChange, fixedWidth, disabled }) => {
    const countries = countriesByIso(i18n.language);
    const options = Object.keys(countries)
        .sort((a, b) => countries[a].name > countries[b].name ? 1 : -1)
        .map(isoCode => {
            return {
                key: isoCode,
                text: countries[isoCode].name,
                value: isoCode
            };
        });

    const onFieldChange = (value) => {
        return onChange ? onChange(value) : true;
    }

    const toIso = (value) => countryIsoFromValue(value) || value || '';
    const toIsoList = (value) => {
        const list = Array.isArray(value) ? value : (value ? [value] : []);
        return list
            .map((item) => countryIsoFromValue(item) || item)
            .filter((item) => item !== '' && item != null);
    };

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            onSelectChange={ onFieldChange }
            format={ toIso }
            parse={ toIso }
            fixedWidth={ fixedWidth }
            clearable
            disabled={ disabled }
        />
    ) : (
        <MultiSelectField
            name={ name }
            options={ options }
            onSelectChange={ onFieldChange }
            format={ toIsoList }
            parse={ toIsoList }
            fixedWidth={ fixedWidth }
            clearable
            disabled={ disabled }
        />
    );
}

export default CountriesField;
